import { FC, useContext, useEffect } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";

import HubInputField from "src/components/inputType";
// import PracticeField from "./treatingReferringFields/practiceField";

import useFetch from "src/hooks/useFetch";
import { CaseContext } from "src/context/caseContext";
import { PracticeDropdownResponse } from "src/components/caseStepTwo/types";
import { APIEndpoints } from "src/types/apiTypes";




const SubmittingPracticeField: FC = (): JSX.Element => {
  const { formControls } = useContext(CaseContext)
  const submitting_practice = formControls?.watch("doctor_attributes.submitting_practice_id")
  const i_am = formControls?.watch("doctor_attributes.i_am")

  /**
   * @getPracticeDropdown api to get practice based listing
   * @first initialize the useFetch() hook
   * @second trigger practice listing api to get listing
   * mutate: getPracticeListing
   */
  const {data: practiceDropdownApiRes } = useFetch<PracticeDropdownResponse>(APIEndpoints.PRACTICE_DROPDOWN, {});



  useEffect(() => {
    if (formControls && i_am && submitting_practice) {
      if (["Treating Provider", "Treating Facility"].includes(i_am)) {
        if (i_am === "Treating Facility") {
          formControls.setValue("doctor_attributes.treating_practice_id", submitting_practice)
        }
        formControls.resetField("doctor_attributes.treating_doctor_id", { defaultValue: 0 })
      } else if (["Referring Facility", "Referring Provider"].includes(i_am)) {
        formControls.setValue("doctor_attributes.referring_practice_id", submitting_practice)
        formControls.resetField("doctor_attributes.referring_doctor_id", { defaultValue: 0 })
      }
      formControls.resetField("patient_attributes")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitting_practice])



  return (
    <div className="col-md-10">
      {formControls ? (
        <>
          {/* <PracticeField
            control={formControls.control}
            fieldName="doctor_attributes.submitting_practice_id"
            getPracticeListing={}

          /> */}
          <Controller
            name="doctor_attributes.submitting_practice_id"
            control={formControls?.control}
            render={({ field, fieldState: { error } }) => (
              <div className="row">
                <div className="col-12 col-md-4 col-lg-3 mt-md-2 mt-0 mt-lg-2">
                  <label htmlFor="doctor_attributes.submitting_practice_id" className="form-label">
                    Submitting Practice *
                  </label>
                </div>
                <div className="col-12 col-md-8 col-lg-9">
                  <HubInputField
                    inputId="doctor_attributes.submitting_practice_id"
                    // inputLabel="Submitting Practice"
                    inputPlaceholder="Select a Practice..."
                    isRequired={true}
                    isRowBased={true}
                    field={field}
                    error={error}
                    isDropdown={true}
                    isSearchable={false}
                    isTypeAhead
                    dropdownData={
                      (practiceDropdownApiRes && practiceDropdownApiRes.data && practiceDropdownApiRes.data.length > 0 ?
                        practiceDropdownApiRes.data.map((practice) => ({ label:  practice.address ? `${practice.name.charAt(0).toUpperCase() + practice.name.slice(1)} - ${practice.address.full_address}` : practice.name , value: practice.id }))
                        : []
                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                    }
                  />
                </div>
              </div>
            )}
          />
        </>
      ) : null}
    </div>
  )
}

export default SubmittingPracticeField
